import React, { useState } from 'react';
import ImageModal from '../modals/ImageModal';
import { IMAGES } from '../../constants/artForms';

const Gallery = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    return (
        <section id="gallery" className="py-16 md:py-24 bg-black">
            <div className="container mx-auto px-4 md:px-8">
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-12 text-center section-heading mx-auto">
                    Gallery
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {IMAGES.GALLERY.map((image, index) => (
                        <div 
                            key={index}
                            className="rounded-xl overflow-hidden shadow-lg transform hover:scale-105 transition duration-300 ease-in-out cursor-pointer" 
                            onClick={() => {
                                setSelectedImage(image);
                                setSelectedIndex(index);
                            }}
                            role="button"
                            tabIndex={0}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    setSelectedImage(image);
                                    setSelectedIndex(index);
                                }
                            }}
                            aria-label={`View gallery image ${index + 1}`}
                        >
                            <img 
                                src={image} 
                                alt={`Item ${index + 1}`} 
                                className="w-full h-64 object-contain" 
                            />
                        </div>
                    ))}
                </div>
            </div>

            {selectedImage && (
                <ImageModal
                    image={selectedImage}
                    onClose={() => setSelectedImage(null)}
                    onNext={() => {
                        if (selectedIndex < IMAGES.GALLERY.length - 1) {
                            setSelectedImage(IMAGES.GALLERY[selectedIndex + 1]);
                            setSelectedIndex(selectedIndex + 1);
                        }
                    }}
                    onPrev={() => {
                        if (selectedIndex > 0) {
                            setSelectedImage(IMAGES.GALLERY[selectedIndex - 1]);
                            setSelectedIndex(selectedIndex - 1);
                        }
                    }}
                    hasNext={selectedIndex < IMAGES.GALLERY.length - 1}
                    hasPrev={selectedIndex > 0}
                />
            )}
        </section>
    );
};

export default Gallery;
